module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content) ? _c('div', {
    staticClass: "gallery"
  }, [_c('h2', {
    staticClass: "gallery__title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }), _c('div', {
    staticClass: "gallery__container"
  }, _vm._l((_vm.content.gallery), function(image, i) {
    return _c('div', {
      key: i,
      staticClass: "gallery__photo",
      style: ({
        'background': 'url(' + image.photo + ')' + ' no-repeat ' + ' center ',
        'background-position': 'center 40%'
      })
    })
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28297898","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-news-gallery/custom-news-gallery.pug
// module id = 621
// module chunks = 1